import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/react-hooks';
import { kmsClient } from '../../apollo';
import { ArticleCreativesQuery, ArticleCreativesQueryVariables } from './__generated__/ArticleCreativesQuery';

export const ARTICLE_CREATIVES_QUERY = gql`
  query ArticleCreativesQuery($id: ID!) {
    article(id: $id) {
      creatives {
        id
        createdAt
        creativesProblematicKeywords {
          severity
          expressionRegex
        }
        linkHeadline
        creativeStatus
        postText
        articleId
        postId
        source
        negativeRatio
        reviewStatus
        description
        leadGenFormId
        facebookLeadgenForm {
          discardedAt
        }
        negativeFeedback
        numberOfFacebookAds
        numberOfActiveFacebookAds
        reviewTime
        reviewReason
        reviewerEmail
        reviewMessage
        reviewMessageHeadline
        internalReviewerEmail
        reviewMessageDescription
        reviewMessageText
        instagramObjectId
        instagramLink
        facebookLink
        isVideoCreative
        adCreativeSpec
        linkFromStorySpec
        fullUrl
        uploadAdPolicy
        facebookPageId
        facebookPageName

        origin {
          creationMethod
          anywordTemplateName
          postTextSource {
            source
            anywordTemplateId
            anywordTemplateName
          }
          headlineSource {
            source
            anywordTemplateId
            anywordTemplateName
          }
        }

        creativeTemplate {
          __typename
          ... on ImageOrVideoCreativeTemplate {
            id
            sourceType
            callToAction
            hasCreatives
            hasFacebookAds
            postText {
              id
              text
            }
            headline {
              id
              text
            }
            description {
              id
              text
            }
            image {
              id
              url
            }
            imageType
            videoId
          }

          ... on CarouselCreativeTemplate {
            __typename
            id
            creator {
              id
              email
            }
            sourceType
            callToAction
            message
            carouselAssetSpecs
          }
        }

        qualityRankings {
          name
          numberOfAds
        }

        disapprovedAdsStatistic {
          disapprovedCount
          disapprovedRatioPercentage
        }

        creativeStatistics {
          ctr
          spent
          clicks
          impressions
        }
      }
    }
  }
`;

export const useArticleCreativesLazyQuery = (variables: ArticleCreativesQueryVariables) => {
  return useLazyQuery<ArticleCreativesQuery, ArticleCreativesQueryVariables>(ARTICLE_CREATIVES_QUERY, {
    variables,
    client: kmsClient,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true
  });
};
